export enum PAYMENT_MODE {
    UPI=3,
    NET_BANKING=0,
    CHEQUE=1,
    NEFT=2,
	OTM=4
}